export const verifyAuth = async ({
  auth,
  navigate,
  cars,
  rentals,
  coupons,
  contact,
  drivers,
  tours,
  tourBookings,
  employeeService,
  setCarsData,
  setRentalsData,
  setCouponsData,
  setTransfersData,
  setDriversData,
  setToursData,
  setTourBookingsData,
  setEmployeesData,
  setSeasonalPricing,
  setIsLoading,
  setError,
  fetchDurationDiscounts,
  setDurationDiscounts,
  fetchData
}) => {
  try {
    const token =
      localStorage.getItem("adminToken") ||
      localStorage.getItem("Authentication:") ||
      localStorage.getItem("token");

    if (!token) {
      throw new Error("No token found");
    }

    await auth.getCurrentUser();

    await Promise.all([
      fetchData(
        cars,
        rentals,
        coupons,
        contact,
        drivers,
        tours,
        tourBookings,
        employeeService,
        setCarsData,
        setRentalsData,
        setCouponsData,
        setTransfersData,
        setDriversData,
        setToursData,
        setTourBookingsData,
        setEmployeesData,
        setSeasonalPricing,
        setIsLoading,
        setError
      ),
      fetchDurationDiscounts({ rentals, setDurationDiscounts }),
    ]);
  } catch (error) {
    console.error("Authentication failed:", error);
    navigate("/admin/login");
  }
};
